import React from 'react';
import MultiSelect from 'components/common/MultiSelect';

// Services & helpers
import TageService from 'services/TagService';

// Components
import Loader from 'components/common/Loader';

class TagSelector extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
    }

    componentDidMount() {
        this.load();
    }

    async load() {
        const { type } = this.props;
        const tags = await TageService.list({ type });
        this.setState({
            tags,
            isLoading: false
        });
    }

    render() {
        const {
            tagIDs,
            onChange,
            creatable,
            type
        } = this.props;
        const {
            tags,
            isLoading
        } = this.state;

        if (isLoading) {
            return (<Loader isInline />);
        }

        return (
            <MultiSelect
                creatable={creatable}
                className="react-select-container multi-select"
                classNamePrefix="react-select"
                options={tags}
                value={tags.filter(t => tagIDs.indexOf(t.id) != -1)}
                getOptionValue={t => t.id}
                getNewOptionData={(value, label) => ({
                    id: value,
                    name: label,
                    __isNew__: true
                })}
                getOptionLabel={t => {
                    if (t.__isNew__) {
                        return 'Add new tag: ' + t.name;
                    }
                    return t.name
                }}
                onCreateOption={async (name) => {
                    this.setState({ isLoading: true });
                    const { id } = await TageService.save({ name, type, backColour: '#FFFFFF', textColour: '#000000' });
                    const tags = [...this.state.tags];
                    tags.push({ id, name });
                    this.setState({ tags, isLoading: false });
                    onChange([...tagIDs, id]);
                }}
                onChange={v => onChange(v.map(t => t.id))}
                placeholder={tagIDs.length == 0 ? '(None)' : tagIDs.map(id => {
                    const tag = tags.find(t => t.id == id);
                    if (tag) return tag.name;
                    else return '';
                }).join(', ')}
            />
        );
    }

}

export default TagSelector;